import { Phone } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export function FloatingActions() {
  const location = useLocation();
  const phoneNumber = '+919594685818';
  const whatsappNumber = '919594685818';

  if (location.pathname.startsWith('/admin')) return null;

  return (
    <div className="fixed left-0 top-1/2 z-50 flex flex-col" style={{ transform: 'translateY(-50%)' }} data-testid="floating-contact">

      {/* WhatsApp — sideways tab */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=Hi%2C%20I%E2%80%99m%20interested%20in%20your%20modular%20furniture%20products.`}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center gap-1.5 bg-[#25D366] text-white shadow-lg hover:bg-[#1ebe5b] transition-colors font-bold rounded-b-md whitespace-nowrap"
        style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)', padding: '10px 8px', fontSize: '11px', letterSpacing: '0.05em' }}
        data-testid="floating-whatsapp"
        aria-label="Chat with us on WhatsApp"
      >
        <span className="absolute inset-0 rounded-b-md bg-[#25D366] animate-ping opacity-20 pointer-events-none" />
        <svg className="w-4 h-4 relative z-10" viewBox="0 0 24 24" fill="currentColor" style={{ transform: 'rotate(180deg)' }}>
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        <span className="relative z-10">WhatsApp Us</span>
      </a>

      {/* Phone — sideways tab */}
      <a
        href={`tel:${phoneNumber}`}
        className="flex items-center gap-1.5 bg-[#1a1a1a] text-white shadow-lg hover:bg-[#333] transition-colors font-bold rounded-b-md whitespace-nowrap"
        style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)', padding: '10px 8px', fontSize: '11px', letterSpacing: '0.05em' }}
        data-testid="floating-phone"
        aria-label="Call Modular Furniture Store at 9594685818"
      >
        <Phone className="w-4 h-4" style={{ transform: 'rotate(180deg)' }} />
        <span>Talk to an Expert  9594685818</span>
      </a>
    </div>
  );
}
